import React from 'react';
import { Button } from '../../components/ui/button';
import { CheckCircle, XCircle, ArrowLeft } from 'lucide-react';
import { formatEmployeeName } from './helpers';

export const ActionResult = ({ result, employee, countdown, onBack }) => (
  <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white p-4 sm:p-6 flex items-center justify-center">
    <div className="max-w-md w-full text-center">
      <div className={`w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 rounded-full mx-auto mb-4 sm:mb-6 flex items-center justify-center ${
        result.success ? 'bg-green-500/20' : 'bg-red-500/20'
      }`}>
        {result.success ? (
          <CheckCircle className="h-8 w-8 sm:h-10 sm:w-10 md:h-12 md:w-12 text-green-500" />
        ) : (
          <XCircle className="h-8 w-8 sm:h-10 sm:w-10 md:h-12 md:w-12 text-red-500" />
        )}
      </div>

      <h2 className="text-xl sm:text-2xl font-bold mb-2" data-testid="action-result-title">
        {result.action === 'clock_in' && 'Eingestempelt'}
        {result.action === 'clock_out' && 'Ausgestempelt'}
        {result.action === 'break_start' && 'Pause gestartet'}
        {result.action === 'break_end' && 'Pause beendet'}
      </h2>
      <p className="text-3xl sm:text-4xl font-mono font-bold text-primary mb-3 sm:mb-4">{result.time}</p>
      <p className="text-gray-400 mb-3 sm:mb-4 text-sm sm:text-base">{formatEmployeeName(employee)}</p>

      <p className="text-gray-500 text-xs sm:text-sm mb-4 sm:mb-6">
        Automatische Rückkehr in {countdown} Sekunden...
      </p>

      <Button onClick={onBack} size="lg" className="rounded-full px-6 sm:px-8 h-10 sm:h-12 text-sm sm:text-base">
        <ArrowLeft className="mr-1 sm:mr-2 h-4 w-4 sm:h-5 sm:w-5" />
        Zurück
      </Button>
    </div>
  </div>
);
